// @core/api/endpoints/task/update_status_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  StatusDefinitionResponse,
  UpdateStatusDefinitionRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update status definition
 * Updates a custom status definition (display name, color, position, category mapping).
 */
export async function UpdateStatusDefinition(
  status_id: string,
  data: UpdateStatusDefinitionRequest,
  options?: RequestOptions
): Promise<StatusDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/status-definitions/:status_id`;
  requestPath = requestPath.replace(':status_id', encodeURIComponent(status_id));
  const requestOptions = options;
  return client.put<StatusDefinitionResponse>(requestPath, data, requestOptions);
}
